import { Injectable } from "@angular/core";
import { HttpService } from "../providers/http.service";
import { AppConfig } from "../app/app.config";

@Injectable()
export class YaXingService {
    constructor(private httpService: HttpService, private AppConfig: AppConfig) { }

    /**
     *登录亚星真人
     */
    login() {
        let url = AppConfig.GetProdUrl() + "/YaXing/LoginYaXing";
        return this.httpService.post(url,'');
    }

    /**
     * 转账到亚星真人
     */
    transferToGamYx(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YaXing/TransferToYaXing";
        return this.httpService.post(url, { Amount: amount, Type: 0 })
    }
    /**
     *亚星真人转账到平台
     */
    transferFromYx(amount: number) {
        let url = AppConfig.GetProdUrl() + "/YaXing/TransferFromYaXing";
        return this.httpService.post(url, { Amount: amount, Type: 1 })
    }

    /**
     *获取凯旋棋牌余额
     *
     */
    getBalance() {
        let url = AppConfig.GetProdUrl() + "/YaXing/GetBalance";
        return this.httpService.post(url, '')
    }

    /**
     *获取凯旋棋牌转账记录
     */
    GetTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/YaXing/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**
     *获取凯旋棋牌投注记录
     */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/YaXing/GetBettingList";
        return this.httpService.post(url, params);
    }

}


// WEBPACK FOOTER //
// ./src/services/yaxing.service.ts